var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlusColor = function SvgPlusColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#18A87D",
    fillRule: "evenodd",
    d: "M7.889 3.26c.327 0 .593.265.593.592v3.555h3.555a.593.593 0 1 1 0 1.186H8.482v3.555a.593.593 0 0 1-1.186 0V8.593H3.741a.593.593 0 1 1 0-1.186h3.555V3.852c0-.327.266-.593.593-.593",
    clipRule: "evenodd"
  })));
};
export default SvgPlusColor;